// Tracks, per Amplitude session, the variant value that was actually exposed - so the
// coachmark gate can be locked to that same value for the rest of the session. Without this,
// a slow/late-resolving fetch that changes the live variant after the first exposure already
// logged would let the UI render a different arm than the one Amplitude was told was exposed,
// corrupting the experiment's analysis.
const exposedCloserStoreCoachmarkVariantBySession = new Map<string, string>();

export const hasHandledCloserStoreCoachmarkExposureSession = (dedupeKey: string) =>
  exposedCloserStoreCoachmarkVariantBySession.has(dedupeKey);

export const markCloserStoreCoachmarkExposureSessionHandled = (
  dedupeKey: string,
  variantValue: string
) => {
  exposedCloserStoreCoachmarkVariantBySession.set(dedupeKey, variantValue);
};

export const getExposedCloserStoreCoachmarkVariantForSession = (
  dedupeKey: string
): string | undefined => exposedCloserStoreCoachmarkVariantBySession.get(dedupeKey);

/**
 * Clears every locked/exposed session for this experiment. Must be called whenever the guest's
 * identity changes (login or logout) - an Amplitude session id can outlive an identity change,
 * so without this a variant locked/exposed under the previous identity would keep gating and
 * suppressing exposure for the newly re-fetched assignment, with no exposure logged for it.
 */
export const clearCloserStoreCoachmarkExposureSessions = () => {
  exposedCloserStoreCoachmarkVariantBySession.clear();
};
